<template>
    <q-page class="reset" :class="{'bg-white': !$isDesktop}">
        <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
            <q-card v-if="$isDesktop" class="col-6">
                <common-form :action="$route('auth.password-reset')">
                    <q-card-section class="q-pa-lg">
                        <reset-form :token="token" />
                    </q-card-section>
                    <q-separator />
                    <q-card-actions align="between" class="q-py-md q-px-lg">
                        <accent-button label="Reset uw wachtwoord" type="submit" />
                    </q-card-actions>
                </common-form>
            </q-card>
            <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
                <common-form :action="$route('auth.password-reset')">
                    <reset-form :token="token" />
                    <q-separator />
                    <div class="row justify-end q-mt-md">
                        <accent-button label="Reset uw wachtwoord" type="submit" />
                    </div>
                </common-form>
            </div>
        </div>
    </q-page>
</template>

<script>
import ResetForm from './form/Reset'

export default {
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    components: {
        ResetForm,
    },
}
</script>
